Action = require 'models/action'
CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Promise = require 'bluebird'
_ = require 'underscore'
ApiError = require 'network/api-error'

module.exports = class ActionList extends CollectionWithHelpers
  model: Action

  initialize: (list, @options) ->

  comparator: (action) ->
    -action.getDate() || 0

  _getRelatedBoards: ->
    idBoardsRelated =
      for model in @models when model.get('type') in ['moveCardToBoard', 'moveCardFromBoard']
        data = model.get('data')
        data.boardTarget?.id || data.boardSource?.id

    idBoardsRelated = _.compact(_.uniq(idBoardsRelated))
    idBoardsRelated = _.reject(idBoardsRelated, (idBoard) => @modelCache.get('Board', idBoard)?)

    Promise.resolve(idBoardsRelated)
    .map (idBoard) =>
      ModelLoader.loadBoardName idBoard
      .catch ApiError.Unauthorized, ApiError.NotFound, (->)



// WEBPACK FOOTER //
// ./app/scripts/models/collections/action-list.coffee